import axiosWrapper from '../axiosWrapper/axiosWrapper';
import restAxiosWrapper from '../axiosWrapper/rest-axiosWrapper';

import {apiErrorHandler} from './api_error_handler/api_error_handler';

import {appStore} from '../redux/createStore';

import log from 'loglevel';
const OKTA_TOKEN_STORAGE = 'okta-token-storage';

let states;
appStore?.subscribe(() => {
  states = appStore.getState().appStates;
});

export const getReduxStateData = (url, params, store) => {
  let stateData;
  stateData = states[store.stateName];
  return stateData;
};
export const dispatchReduxStateData = (url, store, params, apiResponse) => {
  appStore.dispatch(store.actionName(apiResponse));
};
export const getAPICall = async (url, params, store) => {
  let apiResponse = {body: {}};

  if (store.stateName && states && getReduxStateData(url, params, store)) {
    apiResponse = getReduxStateData(url, params, store);
  } else {
    const apiRequest = url.startsWith('activateEmail')
      ? restAxiosWrapper.get(url)
      : axiosWrapper.get(url);

    await apiRequest.then(
      async (response) => {
        if (response.data) {
          if (/^(4\d{2})/.test(response.data.status)) {
            apiResponse = {
              isError: true,
            };
          } else {
            apiResponse = response.data;
            if (store.stateName) {
              dispatchReduxStateData(url, store, params, apiResponse.body);
            }
          }
        }
      },
      (error) => {
        apiResponse = {
          isError: true,
        };
        log.error(error);
        let oktaTokenStoage =
          localStorage.getItem(OKTA_TOKEN_STORAGE) &&
          JSON.parse(localStorage.getItem(OKTA_TOKEN_STORAGE));
        if (oktaTokenStoage?.accessToken) {
          apiErrorHandler(
            error,
            params.errorTag,
            '/oops',
            params.hasOwnProperty('redirectToOops')
              ? params.redirectToOops
              : true
          );
        }
      }
    );
  }
  return apiResponse.body ? apiResponse.body : apiResponse;
};

export const postAPICall = async (
  url,
  payload,
  params,
  redirectErrorCallBack
) => {
  let apiResponse = {};
  const apiRequest =
    url === 'verification' ||
    url === 'getcustomer' ||
    url === 'otp'
      ? restAxiosWrapper.post(url, payload)
      : axiosWrapper.post(url, payload);

  await apiRequest.then(
    (response) => {
      apiResponse = response?.data;
    },
    (error) => {
      log.error(error);
      if (!error.response || error.response.status !== 404) {
        apiErrorHandler(
          error,
          params.errorTag,
          '/oops',
          params.hasOwnProperty('redirectToOops') ? params.redirectToOops : true
        );

        if (redirectErrorCallBack) {
          redirectErrorCallBack();
        } else if (error.response) {
          apiResponse.status = error.response.status;
        }
      }
    }
  );
  return apiResponse;
};
